// extracted by mini-css-extract-plugin
export default {"cardContainer":"EmbedCard_cardContainer__iUBJF"};